module.exports = __webpack_public_path__ + "img/guangxi.5d4af7a5.png";